import t from "../helpers/t";
import { $, _, moment } from "../../../vendor";
import React, { useState } from "react";
import { in_array } from "../../utils/Helper";
import SortNav from "./SortNav";
import {
  Filter,
  FieldsMap,
  SelectedIds,
  Tab,
  Extra,
  FieldsItem,
} from "./Types/InboomaSelectBoxTypes";

type Props = {
  itemsPending: { [key: string]: any };
  items: { [key: string]: any };
  getItems: (filter: Filter | null) => void;
  standardFilter: Filter;
  sortBy?: string;
  sortDirection?: string;
  _onSelectedItem: (item: any) => void;
  advanced?: boolean;
  quickOrder?: boolean;
  fields: FieldsMap;
  model: string;
  close: () => void;
  selectedIds: SelectedIds;
  disabled?: boolean;
};
const InboomaSelectBoxItem = ({
  itemsPending,
  items,
  getItems,
  standardFilter,
  sortBy,
  sortDirection,
  _onSelectedItem,
  advanced,
  quickOrder,
  fields,
  model,
  close,
  selectedIds,
}: Props) => {
  const [_sortBy, _setSortBy] = useState(sortBy);
  const tooltipPosition = () => {
    return "60px";
  };
  console.log(model, "model");
  console.log(itemsPending);
  console.log(items);
  const shorten = (value: any, maxLength: number) => {
    let maxWidth: number =
      window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; // does only work for initial value and not for resize

    if (maxWidth < 500) {
      maxLength = 16; // set fixed limit for small screens
    }
    if (value === undefined || value == null) return "";
    if (value.length > maxLength && maxLength > 3) {
      return value.substring(0, maxLength - 3) + "...";
    } else {
      return value;
    }
  };
  const _toggleSortDirection = (id: string) => {
    const el: any = document.getElementById(id);
    if (el !== null && el.className.indexOf("asc") < 0 && el.className.indexOf("desc") >= 0) {
      // current direction is 'desc'
      el.className = el.className.replace("desc", "asc");
      return "asc";
    } else if (
      el !== null &&
      el !== null &&
      el.className.indexOf("asc") >= 0 &&
      el.className.indexOf("desc") < 0
    ) {
      // current direction is 'asc'
      el.className = el.className.replace("asc", "desc");
      return "desc";
    } else {
      // direction inconsistent
      return null;
    }
  };

  const _setActiveSort = (el: any) => {
    if (el.className.indexOf("inb-select-sort-menu") < 0) return;

    if (el.className.indexOf("active") >= 0) return; // only direction has been changed -> do nothing

    // find active element
    let elems: HTMLCollectionOf<Element> = document.getElementsByClassName("active");
    if (elems !== null) {
      for (let i = 0; i < elems.length; i++) {
        // @ts-ignore
        if (
          elems[i].parentNode !== null &&
          elems[i].parentNode.className.indexOf("inb-select-results-head") >= 0
        ) {
          // found active sort element
          // @ts-ignore
          elems[i].classList.remove("active");
          el.classList.add("active");
          el.children[0].children[0].classList.remove("hide");
          return;
        }
      }
    }
  };
  const _sort = (ev: any) => {
    let el: any = ev.target.parentNode;
    let sort_dir: any = null;

    if (ev.target.tagName === "I") el = ev.target.parentNode.parentNode;
    _setActiveSort(el);
    let filter: Filter = {};
    Object.assign(filter, standardFilter);
    let newObj: { [key: string]: string } = {},
      mapper: { [key: string]: string } = {};
    fields.fieldNames.map((fieldName) => {
      // @ts-ignore
      newObj["select_sort_" + fields.fieldMap[fieldName].number] = fieldName;
      // @ts-ignore
      mapper["select_sort_" + fields.fieldMap[fieldName].number] =
        "sort_arrow_" + fields.fieldMap[fieldName].number;
    });
    // @ts-ignore
    sort_dir = _toggleSortDirection(mapper[el.id]);
    if (sort_dir != null) {
      filter.sort = newObj[el.id];
      filter.direction = sort_dir;
      getItems(filter);
    }
  };

  const isActiveSort = (sort: string) => {
    if (sort === _sortBy) return true;
    return false;
  };

  const getDirection = (sort: string) => {
    if (sort === _sortBy) {
      return sortDirection;
    } else {
      let elems: any = document.getElementsByClassName("fi-play");
      for (let i: number = 0; i < elems.length; i++) {
        if (elems[i].className.indexOf("hide") >= 0) {
        } else {
          elems[i].classList.add("hide");
        }
      }
      return "asc";
    }
  };

  let tabs: Tab[] = [];
  fields.fieldNames.map((key) => {
    // @ts-ignore
    const field: FieldsItem = fields.fieldMap[key];
    let direction: string = "asc";
    if (sortDirection) {
      direction = sortDirection;
    }
    tabs.push({
      name: field.label,
      style: field.style,
      title: field.label,
      canSort: true,
      preselected: isActiveSort(key),
      sort: {
        direction: _sortBy === key ? direction : "asc",
        data_inb_val: key,
      },
    });
  });
  const onSortChangedHandle = (ev: React.MouseEvent<HTMLLIElement>) => {
    const el: any = ev.currentTarget;
    const sortKey: any = el.getAttribute("data-inb-val"),
      direct: any = el.getAttribute("data-inb-direction"),
      isOppositeElement: any = direct === null && el.classList.contains("is-active"),
      newDirection: any = direct === "desc" || isOppositeElement ? "asc" : "desc";

    if (sortKey) {
      let requestFilter: Filter;
      if (typeof standardFilter.limit !== "undefined") {
        requestFilter = {
          ...standardFilter,
          sort: sortKey,
          direction: direct,
        };
      } else {
        requestFilter = {
          ...standardFilter,
          sort: sortKey,
          direction: direct,
          limit: 999,
          page: 1,
        };
      }

      getItems(requestFilter);
      const activeSortTab = $(".is-active");
      _.each(activeSortTab, function (key: any) {
        key["classList"].remove("is-active");
      });
      el.classList.add("is-active");
      el.setAttribute("data-inb-direction", isOppositeElement ? "desc" : newDirection);
    }
  };
  return (
    <>
      {advanced && (
        <>
          <div
            id={"inb-select-results-head_" + model}
            className="inb-select-results-head hide"
            style={quickOrder ? { overflow: "hidden", width: "100%" } : {}}
          >
            {/*{fields.fieldNames.map(key => {
                    const field = fields.fieldMap[key];
                    return (
                        <>
                                <span id={"select_sort_"+field.number} className={"inb-select-sort-menu "+field.class + (isActiveSort(key)?' active':'')} title={t('sort_by_${a}',{a:field.label})} key={key+"_sort"}>
                                    <a href="#" className="inb-select-box-sort" onClick={_sort}>
                                       {field.label}
                                         <i style={{paddingLeft:"5px"}} id={"sort_arrow_"+field.number} className={"fi-play " + getDirection(key)+' '+(isActiveSort(key)?'':'hide')}></i>
                                    </a>
                                </span>
                        </>
                    )
                })}*/}
            <div className="sticky-container" style={{ fontWeight: "bold", width: "100%" }}>
              <SortNav
                tabs={tabs}
                listStyle="tight"
                autoHeight={false}
                handler={onSortChangedHandle}
              />
            </div>
            <a
              href="#"
              id={"inbooma-select-box__reset2_" + model}
              className="inbooma-select-box__reset2"
              onClick={close}
              style={{ width: "18px" }}
            >
              x
            </a>
          </div>
        </>
      )}
      <ul
        id={"inbooma-select-box-results_" + model}
        className={"inbooma-select-box-results hide default-offset"}
      >
        <>
          {itemsPending[model] && (
            <>
              <div style={{ maxHeight: "40px", width: "100%", textAlign: "center" }}>
                <img className="rollingLoader colorize-black" src="assets/img/rolling_loader.svg" />
              </div>
            </>
          )}
          {!itemsPending[model] && items[model].length === 0 && (
            <span>{t("no results found", null, "capital")}</span>
          )}
          {!itemsPending[model] &&
            items[model].length > 0 &&
            items[model].map((item: any, key: string | number) => {
              return (
                <>
                  {!in_array(item.id, selectedIds[model]) && (
                    <>
                      <li
                        className={"inbooma-select-box-results__field"}
                        key={key}
                        onClick={() => {
                          _onSelectedItem(item);
                        }}
                      >
                        {fields.fieldNames.map((keyName) => {
                          const field = fields.fieldMap[keyName];
                          // @ts-ignore
                          if (field.type === "extra" && typeof field.extra !== "undefined") {
                            // @ts-ignore
                            let extra: Extra = field.extra;
                            let seperator: string = "";
                            let subModel: string = "";
                            let descriptor: string = "";
                            // let fieldsNew:FieldMap[] = [];
                            let type: string = "standard";
                            Object.keys(extra).map((f) => {
                              if (typeof extra["seperator"] === "string") {
                                // @ts-ignore
                                seperator = extra[f].toString();
                              } else if (f === "descriptor") {
                                // @ts-ignore
                                descriptor = extra[f].toString();
                              } else if (f === "type") {
                                // @ts-ignore
                                type = extra[f].toString();
                              } else {
                                subModel = f;
                                if (typeof extra[f] !== "string") {
                                  // @ts-ignore
                                  fields.fieldMap[f] = extra[f];
                                }
                              }
                            });
                            item[keyName] = "";
                            // @ts-ignore
                            if (fields.fieldMap.length > 1) {
                              // @ts-ignore
                              fields.fieldMap.map((field) => {
                                if (item[keyName] !== "") {
                                  item[keyName] += seperator;
                                }
                                if (descriptor === "object") {
                                  let sub = item[subModel];
                                  if (sub !== null) {
                                    item[keyName] +=
                                      type === "date"
                                        ? moment(sub[field]).format("DD.MM.YYYY, HH:mm")
                                        : sub[field];
                                  }
                                } else {
                                  item[keyName] +=
                                    type === "date"
                                      ? moment(item[subModel][0][field]).format("DD.MM.YYYY, HH:mm")
                                      : item[subModel][0][field];
                                }
                              });
                            }
                          }
                          return (
                            <>
                              <span
                                className={field?.class}
                                key={key + "_" + item.id}
                                title={item[keyName]}
                              >
                                {field?.type === "image" ? (
                                  <img
                                    alt=""
                                    src={item[keyName]}
                                    style={{ width: "30px", height: "30px" }}
                                  />
                                ) : field?.type === "toShorten" ? (
                                  shorten(item[keyName], 30)
                                ) : field?.date ? (
                                  moment(item[keyName]).format("DD.MM.YYYY, HH:mm")
                                ) : (
                                  item[keyName]
                                )}
                              </span>
                              {/*{model === 'user' && <> <div id={"tt_" + item.id} className={"tooltip " + ((advanced && !quickOrder) ? 'advanced' : '')} style={{top: tooltipPosition()}}>
                                                    <label>
                                                        {item.last_name + ', ' + item.first_name}
                                                    </label>
                                                    <label>
                                                        <i className="fi fi-torso"></i>
                                                        {item.customer_nbr}
                                                    </label>
                                                    <label>
                                                        <i className="fi fi-mail"></i>
                                                        {item.email}
                                                    </label>
                                                    <label>
                                                        <div className="inb-fi-card"></div>
                                                        {item.id_card_nbr == null ? '-' : item.id_card_nbr}
                                                    </label>
                                                    <label>
                                                        <div className="inb-fi-created-at"></div>
                                                        {moment(item.created).format('DD.MM.YYYY, HH:mm')}
                                                    </label>
                                                </div>
                                                </>}*/}
                            </>
                          );
                        })}
                      </li>
                    </>
                  )}
                </>
              );
            })}
        </>
      </ul>
    </>
  );
};
export default InboomaSelectBoxItem;
